import {combineLatest} from 'rxjs';
import {filter, map} from 'rxjs/operators';
import {fiat$} from './fiat';
import {indexPricesCache$} from '@/price-index/price-index';
import {toUiMsg$} from '@/ui';
import type {PriceEntity, PricesCache} from '@/types';

export interface UFiatRate {
  type: 'fiat-rate';
  data: {
    fiatRate: PriceEntity;
  };
}

export const fiatRate$ = combineLatest([indexPricesCache$, fiat$]).pipe(
  filter(([indexPricesCache, fiat]: [PricesCache, string]) => indexPricesCache.has('.' + fiat)),
  map(([indexPricesCache, fiat]: [PricesCache, string]) => indexPricesCache.get('.' + fiat))
);

fiatRate$
  .pipe(map((fiatRate): UFiatRate => ({type: 'fiat-rate', data: {fiatRate}})))
  .subscribe((msg) => toUiMsg$.next(msg));
